import React from "react";
import { AccountTabTiles } from "@components/molecules";
import * as S from "./styles";
export var AccountTab = function AccountTab() {
  return React.createElement(S.Wrapper, null, React.createElement(AccountTabTiles, null));
};